import { render, staticRenderFns } from "./TrendSearch.vue?vue&type=template&id=595299e8"
import script from "./TrendSearch.vue?vue&type=script&lang=js"
export * from "./TrendSearch.vue?vue&type=script&lang=js"
import style0 from "./TrendSearch.vue?vue&type=style&index=0&id=595299e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports